"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var AdminCoursesEditController = /** @class */ (function () {
    function AdminCoursesEditController(UserService, PoliciesModel, $state, $scope, UsersModel, CoursesModel, FlashService, ClassroomsModel, course, courseTypes, LocationsModel) {
        var _this = this;
        this.course = course;
        this.user = UserService.getCurrentUser();
        this.courseTypes = courseTypes;
        this.today = new Date();
        this.loading = true;
        this.$state = $state;
        this.$scope = $scope;
        this.UsersModel = UsersModel;
        this.PoliciesModel = PoliciesModel;
        this.LocationsModel = LocationsModel;
        this.CoursesModel = CoursesModel;
        this.ClassroomsModel = ClassroomsModel;
        this.FlashService = FlashService;
        this.getInstructors = this.getInstructors.bind(this);
        this.getClassrooms = this.getClassrooms.bind(this);
        this.clearForm = this.clearForm.bind(this);
        this.updateForm = this.updateForm.bind(this);
        this.delete = this.deleteCourse.bind(this);
        this.submit = this.submit.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.handleLocationChange = this.handleLocationChange.bind(this);
        this.setup()
            .then(function () {
            _this.loading = false;
            _this.$scope.$apply();
        })
            .catch(function (error) {
            console.error("Error in setup:", error);
            _this.loading = false;
            _this.$scope.$apply();
        });
    }
    AdminCoursesEditController.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var locations;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.LocationsModel.getLocations()];
                    case 1:
                        locations = _a.sent();
                        this.locations = locations;
                        // const policiesResponse = this.PoliciesModel.getByID('courses');
                        // set initial location
                        this.course.location = this.locations.find(function (location) { return location.id === _this.course.location.id; });
                        this.course.type = this.courseTypes.find(function (type) { return type.id === _this.course.type.id; });
                        return [4 /*yield*/, this.getClassrooms()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getInstructors()];
                    case 3:
                        _a.sent();
                        if (this.course.classroom) {
                            this.course.classroom = this.classrooms.find(function (room) { return room.id === _this.course.classroom.id; });
                        }
                        this.course.classes = this.course.classes.map(function (courseClass) {
                            var id = courseClass.instructor ? courseClass.instructor.id : 0;
                            courseClass.instructor = _this.instructors.find(function (instructor) { return instructor.id === id; });
                            return courseClass;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminCoursesEditController.prototype.getInstructors = function () {
        var _this = this;
        var params = {
            location: this.course.location,
        };
        params.course = this.course;
        return this.UsersModel.searchInstructors(params).then(function (response) {
            // @todo this is because the form controls are being built with the IInstructor type
            // this should be handled better later
            _this.instructors = [{ id: 0, fullname: "None" }].concat(response.instructors);
        });
    };
    AdminCoursesEditController.prototype.getClassrooms = function () {
        var _this = this;
        var params = {
            location: { id: this.course.location.id },
        };
        return this.ClassroomsModel.search(params).then(function (response) {
            _this.classrooms = response.classrooms;
        });
    };
    AdminCoursesEditController.prototype.clearForm = function () {
        this.course.classroom = null;
    };
    AdminCoursesEditController.prototype.updateForm = function () {
        this.getClassrooms();
        this.getInstructors();
    };
    AdminCoursesEditController.prototype.deleteCourse = function () {
        var _this = this;
        this.CoursesModel.delete(this.course).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.$state.go("drivecoach.admin.calendar", {}, { reload: true });
        });
    };
    AdminCoursesEditController.prototype.handleLocationChange = function (location_id) {
        this.course.location = this.locations.find(function (location) { return location.id == location_id; });
        this.getClassrooms();
        this.getInstructors();
    };
    AdminCoursesEditController.prototype.handleLinkClick = function (data) {
        this.$state.go(data.destination, data.params);
    };
    AdminCoursesEditController.prototype.submit = function (data) {
        var _this = this;
        this.submitted = true;
        var payload = Object.assign({}, data);
        payload.classes = payload.classes.map(function (c) {
            if (!c.instructor || c.instructor.id === 0) {
                delete c.instructor;
            }
            return c;
        });
        this.CoursesModel.update(payload)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.submitted = false;
            _this.$state.go("drivecoach.admin.courses.view", {
                courseId: _this.course.id,
            });
        })
            .catch(function (error) {
            console.log("error", error);
            _this.submitted = false;
        });
    };
    return AdminCoursesEditController;
}());
AdminCoursesEditController.$inject = [
    "UserService",
    "PoliciesModel",
    "$state",
    "$scope",
    "UsersModel",
    "CoursesModel",
    "FlashService",
    "ClassroomsModel",
    "course",
    "courseTypes",
    "LocationsModel",
];
exports.default = AdminCoursesEditController;
